/**
 * Created by shobhitjain on 16/01/20.
 */

import React, { Component } from 'react';
import TabListView from '../../../../components/TabListView';
import NoDataToDisplay from '../../../../components/NoDataToDisplay/index';
import Table from '../TookiTakiTable/Table/index';
import TableHeader from '../../../../components/TableHeader/index';
import TableRows from '../TookiTakiTable/TableRows/TableRows';
import TitleBar from '../../../../components/TitleBar/index';
import Wait4Me from '../../../../components/Wait4Me';
import { convertToFormattedMoney } from '../../../../services/util';
import {
  MAX_FRACTION_DIGITS,
  MIN_FRACTION_DIGITS
} from '../../../../util/GlobalConstant';

/**
 * This is a SAVINGS Header for C2A Widget
 * @type {({name: string, key: string}|
 * {name: string, key: string}|
 * {name: string, key: string}|
 * {name: string, key: string}|
 * {name: string, key: string})[]}
 */
export const SAVINGS_HEADER = [
  {
    name: 'Account Number',
    key: 'account_id'
  },
  {
    name: 'Account Currency',
    key: 'account_currency'
  },
  {
    name: 'Account Name',
    key: 'account_name'
  },
  {
    name: 'C2A Relationship',
    key: 'c2a_relationship'
  },
  {
    name: 'Account Opening Date',
    key: 'account_open_date'
  },
  {
    name: 'Account Close Date',
    key: 'account_closed_date'
  },
  {
    name: 'Account Status',
    key: 'account_status'
  },
  {
    name: 'Account Opening Balance ',
    key: 'balance',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'DR Average Balance',
    key: 'account_dr_avg_balance',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'CR Average Balance',
    key: 'account_cr_avg_balance',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  }
];

/**
 * This is a Header Object for CREDIT
 * @type {({name: string, key: string}|
 * {name: string, key: string}|
 * {name: string, key: string}|
 * {name: string, key: string}|
 * {name: string, key: string})[]}
 */
export const CREDIT_HEADER = [
  {
    name: 'Account Number',
    key: 'account_id'
  },
  {
    name: 'Card Number',
    key: 'card_number'
  },
  {
    name: 'Account Currency',
    key: 'account_currency'
  },
  {
    name: 'Account Name',
    key: 'account_name'
  },
  {
    name: 'C2A Relationship',
    key: 'c2a_relationship'
  },
  {
    name: 'Account Opening Date',
    key: 'account_open_date'
  },
  {
    name: 'Account Close Date',
    key: 'account_closed_date'
  },
  {
    name: 'Account Status',
    key: 'account_status'
  },
  {
    name: 'CC Credit Limit',
    key: 'credit_limit',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  }
];

/**
 * This is a Header Object for LOAN
 * @type {({name: string, key: string}|{name: string, key: string}|{name: string, key: string}|{name: string, key: string}|{name: string, key: string})[]}
 */
export const LOAN_HEADER = [
  {
    name: 'Account Number',
    key: 'account_id'
  },
  {
    name: 'Account Name',
    key: 'account_name'
  },
  {
    name: 'Loan Group',
    key: 'loan_group'
  },
  {
    name: 'Loan Purpose Code',
    key: 'loan_purpose_code'
  },
  {
    name: 'Number of Payments',
    key: 'number_of_repayments'
  },
  {
    name: 'Account Opening Date',
    key: 'account_open_date'
  },
  {
    name: 'Account Status',
    key: 'account_status'
  },
  {
    name: 'Loan 1st Disbursement Date',
    key: 'loan_disbursement_date'
  },
  {
    name: 'Outstanding Balance',
    key: 'outstanding_loan_balance',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'loan_installment_amount',
    key: 'loan_installment_amount',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  }
];
/**
 * This is a Header Object for FD
 * @type {({name: string, key: string}|{name: string, key: string}|{name: string, key: string}|{name: string, key: string}|{name: string, key: string})[]}
 */
export const FIXED_DEPOSIT_HEADER = [
  {
    name: 'Account Number',
    key: 'account_id'
  },
  {
    name: 'Account Currency',
    key: 'account_currency'
  },
  {
    name: 'FD Receipt No',
    key: 'fd_receipt_number'
  },
  {
    name: 'Account Name',
    key: 'account_name'
  },
  {
    name: 'C2A Relationship',
    key: 'c2a_relationship'
  },
  {
    name: 'Account Opening Date',
    key: 'account_open_date'
  },
  {
    name: 'Account Close Date',
    key: 'account_closed_date'
  },
  {
    name: 'Account Status',
    key: 'account_status'
  },
  {
    name: 'FD Original Amount',
    key: 'fd_original_amount',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'FD Placement Date',
    key: 'fd_placement_date'
  },
  {
    name: 'FD Maturity Date',
    key: 'fd_maturity_date'
  },
  {
    name: 'FD Withdrawal Date',
    key: 'fd_withdrawal_date'
  }
];

/**
 * This is a multirow map for dual header
 */
const multiRowMap = {
  account_id: ['account_currency'],
  account_name: ['c2a_relationship'],
  account_open_date: ['account_closed_date'],
  loan_group: ['loan_type'],
  loan_purpose_code: ['loan_gl_group'],
  loan_disbursement_date: ['loan_maturity_date'],
  outstanding_loan_balance: ['loan_amount'],
  loan_installment_amount: ['total_repaid_amount']
};

/**
 *
 * @param AltComponent
 * @constructor
 */
const AltRenderer = (AltComponent) => {
  return class extends React.Component {
    render() {
      return (
        <div>
          <AltComponent {...this.props} />
        </div>
      );
    }
  };
};

/**
 * Alternate C2ALoan Header
 * @returns {*}
 * @constructor
 */
const C2ALoanHeader = () => {
  return (
    <thead>
      <tr>
        <th>Account Number</th>
        <th>Account Name</th>
        <th>Loan Group</th>
        <th>Loan Purpose Code</th>
        <th rowSpan="2">Number of Payments</th>
        <th>Account Opening Date</th>
        <th rowSpan="2">Account Status</th>
        <th>Loan 1st Disbursement Date</th>
        <th>Outstanding Balance</th>
        <th>Instalment Amount</th>
      </tr>
      <tr>
        <th>Account Currency</th>
        <th>C2A Relations</th>
        <th>Loan Type</th>
        <th>Loan GL Group</th>
        <th>Account Close Date</th>
        <th>Loan Maturity Date</th>
        <th>Loan Amount</th>
        <th>Total Repayment Value</th>
      </tr>
    </thead>
  );
};

/**
 *
 * @param data Data is API Data
 * @param keys Keys are basically header keys
 * @returns {Table}
 * @constructor
 */
const AltComponentForLoanTab = ({ data, keys }) => (
  <Table>
    <C2ALoanHeader settings={keys} />
    <tbody>
      {data.map((tableRow) => {
        return (
          <tr>
            {keys.map((row) => {
              if (multiRowMap[row.key]) {
                if (row.formatNumeric) {
                  return (
                    <td
                      title={
                        convertToFormattedMoney(
                          tableRow[row.key],
                          MAX_FRACTION_DIGITS
                        ) +
                        '\n ' +
                        convertToFormattedMoney(
                          tableRow[multiRowMap[row.key][0]],
                          MAX_FRACTION_DIGITS
                        )
                      }
                      key={row.key}>
                      <strong>
                        {convertToFormattedMoney(
                          tableRow[row.key],
                          MIN_FRACTION_DIGITS
                        )}
                      </strong>
                      <br />
                      {convertToFormattedMoney(
                        tableRow[multiRowMap[row.key][0]],
                        MIN_FRACTION_DIGITS
                      )}
                    </td>
                  );
                }
                return (
                  <td
                    title={
                      tableRow[row.key] +
                      '\n ' +
                      tableRow[multiRowMap[row.key][0]]
                    }
                    key={row.key}>
                    {row.key === 'account_id' &&
                    tableRow['isAlertedAccount'] ? (
                      <strong style={{ color: '#e85252' }}>
                        {tableRow[row.key]}
                      </strong>
                    ) : (
                      <strong>{tableRow[row.key]}</strong>
                    )}
                    <br />
                    {tableRow[multiRowMap[row.key][0]]}
                  </td>
                );
              }
              return (
                <td title={tableRow[row.key]} key={row.key}>
                  {tableRow[row.key]}
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  </Table>
);

/**
 * Tabs Map Header
 */
const TabsMap = [
  {
    name: 'Checking/ savings',
    key: 'SAVING',
    icon: 'icon24_icon_saving',
    header: SAVINGS_HEADER
  },
  {
    name: 'Credit cards',
    key: 'CREDIT',
    icon: 'icon24_icon_credit_card',
    header: CREDIT_HEADER
  },
  {
    name: 'Loan',
    key: 'LOAN',
    icon: 'icon24_icon_loan',
    header: LOAN_HEADER,
    altRenderer: true,
    renderer: AltComponentForLoanTab
  },
  {
    name: 'Fixed deposit',
    key: 'FD',
    icon: 'icon24_icon_fixed_deposit',
    header: FIXED_DEPOSIT_HEADER
  }
];

/**
 * This is C2AContent component for
 * @param props {activeIndex, tabConfig, data}
 * @returns {*}
 * @constructor
 */
const C2AContent = (props) => {
  const { activeIndex, tabConfig, data } = props;
  console.log('tabConfig', tabConfig);
  return (
    <div className="tab-content">
      {tabConfig.map((tab, index) => {
        if (tab.altRenderer) {
          const NewComponent = AltRenderer(tab.renderer);
          return (
            activeIndex === index && (
              <NewComponent data={data[tab.key]} keys={tab.header} />
            )
          );
        } else {
          return (
            activeIndex === index && (
              <Table>
                <TableHeader data={tab.header} />
                <TableRows keys={tab.header} data={data[tab.key]} />
              </Table>
            )
          );
        }
      })}
      {data.FD.length === 0 &&
        data.CREDIT.length === 0 &&
        data.LOAN.length === 0 &&
        data.SAVING.length === 0 && <NoDataToDisplay />}
    </div>
  );
};

/**
 * This is main C2AWidget component
 */

class C2AWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1
    };
  }

  onSetActiveIndex = (index) => {
    this.setState({ activeIndex: index });
  };

  render() {
    const { c2aData, isC2CLoading, c2aColumnsMap } = this.props;

    const TabsMapWithSettings = [
      {
        name: 'Checking/ savings',
        key: 'SAVING',
        icon: 'icon24_icon_saving',
        header: c2aColumnsMap.SAVINGS_HEADER_SETTINGS
          ? c2aColumnsMap.SAVINGS_HEADER_SETTINGS
          : SAVINGS_HEADER
      },
      {
        name: 'Credit cards',
        key: 'CREDIT',
        icon: 'icon24_icon_credit_card',
        header: c2aColumnsMap.CREDIT_HEADER_SETTINGS
          ? c2aColumnsMap.CREDIT_HEADER_SETTINGS
          : CREDIT_HEADER
      },
      {
        name: 'Loan',
        key: 'LOAN',
        icon: 'icon24_icon_loan',
        header: c2aColumnsMap.LOAN_HEADER_SETTINGS
          ? c2aColumnsMap.LOAN_HEADER_SETTINGS
          : LOAN_HEADER,
        altRenderer: true,
        renderer: AltComponentForLoanTab
      },
      {
        name: 'Fixed deposit',
        key: 'FD',
        icon: 'icon24_icon_fixed_deposit',
        header: c2aColumnsMap.FIXED_DEPOSIT_HEADER_SETTINGS
          ? c2aColumnsMap.FIXED_DEPOSIT_HEADER_SETTINGS
          : FIXED_DEPOSIT_HEADER
      }
    ];

    const { activeIndex } = this.state;
    let TitleName = 'Associated Accounts';
    if (isC2CLoading) {
      return (
        <div>
          <TitleBar title={TitleName} />
          <TabListView
            onSetActiveIndex={this.onSetActiveIndex}
            data={c2aData}
            tabConfig={TabsMapWithSettings}
          />
          <div
            className="row"
            style={{
              textAlign: 'center',
              padding: 10,
              margin: 0,
              backgroundColor: 'white'
            }}>
            <div className="col-md-12">
              <Wait4Me />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <TitleBar title={TitleName} />
        <TabListView
          onSetActiveIndex={this.onSetActiveIndex}
          data={c2aData}
          tabConfig={TabsMapWithSettings}
        />
        <C2AContent
          activeIndex={activeIndex}
          data={c2aData}
          tabConfig={TabsMapWithSettings}
        />
      </div>
    );
  }
}

export default C2AWidget;
